import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { GET } from "../../utils/httpUtils";
import "./dashboard.css";
import { BytesToGb, BytesToMb, cron, Log } from "../../utils/genericUtils";
import subscriptions from "../../constants/subscriptions";
import subscriptionsMaxBytes from "../../constants/subscriptions";

export default function UsageIndicator(props) {
  const { user, loginUser } = useContext(UserContext);
  const [used, setUsed] = useState(user.bytesUsed);

  useEffect(() => {
    set_bytes_used();
  }, [used, props.stateHash]);

  const set_bytes_used = () => {
    Log("bytes before: ", used);
    GET("/storage-capacity", user).then((check_bytes) => {
      Log("check: ", check_bytes);
      if (check_bytes.bytesUsed !== undefined) {
        let bytes = parseFloat(check_bytes.bytesUsed);
        Log("bytes after: ", used);
        loginUser({ ...user, bytesUsed: bytes });
        if (used !== bytes) setUsed(bytes);
      }
    });
  };

  function formatBytesUsed() {
    let mb = BytesToMb(used);
    if (mb >= 1000) return BytesToGb(used).toFixed(2) + "GB";
    else return mb.toFixed(2) + "MB";
  }

  return (
    <section className="usage-section">
      <h1 className="storage-usage-header">Storage Usage</h1>
      <progress
        title={(used / subscriptionsMaxBytes[user.subscription]).toFixed(2) * 100 + "%"}
        className="storage-progress-bar"
        value={used}
        max={subscriptionsMaxBytes[user.subscription]}
      ></progress>
      <p className="storage-sub-text">
        {formatBytesUsed()} used of {Number(BytesToGb(subscriptions[user.subscription]).toFixed(0)).toLocaleString()} GB
      </p>
    </section>
  );
}
